import { backgrounds } from '../../tokens/colors/backgrounds';
import { SharedBoxProps } from '../../types/SharedBoxProps';
import { Layout, LayoutProps } from '../Layout/Layout';
import { presets } from '../Layout/presets';

interface Props extends LayoutProps, SharedBoxProps {
  /** Layout preset */
  preset?: keyof typeof presets;
}

export const GradientOutline = (props: Props) => {
  return (
    <Layout
      p="1px"
      style={{
        border: '1px solid transparent',
        backgroundImage: backgrounds['background.gradient'],
        backgroundOrigin: 'border-box',
        backgroundClip: 'padding-box, border-box',
        borderRadius: '7px',
      }}
    >
      <Layout bg="background" flex="1" borderRadius="5px" {...props}>
        {props.children}
      </Layout>
    </Layout>
  );
};
